module.exports = __webpack_public_path__ + "img/guess-number.bead5f53.png";